// Types
import Nullable from '@/types/nullable';
import LocalizedString from '@/types/localized-string';

export enum DataUploadPortalStep {
  INIT = 'INIT',
  NEW = 'NEW',
  VALIDATING = 'VALIDATING',
  IMPORTING_UAT = 'IMPORTING_UAT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  IMPORTING = 'IMPORTING',
  DONE = 'DONE',
}

export enum DataUploadPortalStatus {
  NONE = 'NONE',
  ONGOING = 'ONGOING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

export enum DataUploadPortalEnvironment {
  UAT = 'UAT',
  PROD = 'PROD',
}

export enum DataUploadPortalLogLevel {
  Warning = 'Warning',
  Error = 'Error',
}

export enum DataUploadPortalGroupType {
  Enterprise = 'Enterprise',
  Groups = 'Groups',
}

export type DataUploadPortalFile = {
  description: LocalizedString;
  key: string;
  name: string;
  createdAt?: string;
  url?: string;
  extensions?: Array<string>;
};

export type DataUploadPortalLog = {
  message: string;
  level?: string;
  context: Nullable<string>;
  at?: Date;
  source: string;
};

export enum DataUploadWorkflowStepExecution {
  ALL_FILES_UPLOADED_CHECK = 'ALL_FILES_UPLOADED_CHECK',
  CREATE_DATA_UPLOAD_TASK = 'CREATE_DATA_UPLOAD_TASK',
  VALIDATE_DATA = 'VALIDATE_DATA',
  IMPORT_DATA = 'IMPORT_DATA',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
}

export type DataUploadWorkflowStep = {
  key: DataUploadPortalStep;
  run: Nullable<DataUploadWorkflowStepExecution>;
  onSuccess: DataUploadPortalStep;
  onFailure: Nullable<DataUploadPortalStep>;
};

export enum DataUploadActionKeys {
  add = 'add',
  cancel = 'cancel',
}

export type DataUploadPortalJobConfig = {
  assets: {
    description: string;
    name: string;
    type: string;
  };
  streamConfigKey: string;
};

export type DataUploadPortalWorkflowStep = {
  key: string;
  onFailure: string;
  onSuccess: string;
  run: string;
};

export type DataUploadPortalConfig = {
  key?: string;
  name: string;
  job?: string;
  target?: string;
  files: Array<DataUploadPortalFile>;
  status?: DataUploadPortalStatus;
  log?: Array<DataUploadPortalLog>;
  validationLog?: Array<DataUploadPortalLog>;
  context?: string;
  jobConfig: DataUploadPortalJobConfig;
  workflow: {
    steps: Array<DataUploadPortalWorkflowStep>;
    canNextStep: boolean;
    canCancel: boolean;
    messageKey: string;
  };
  configKey?: string;
  dataUpload?: {
    environment?: DataUploadPortalEnvironment;
    status?: DataUploadPortalStatus;
    step?: DataUploadPortalStep;
    log?: Array<DataUploadPortalLog>;
    validationLog?: Array<DataUploadPortalLog>;
  };
  groups: {
    targetedGroups: {
      names: Array<string>;
      jobType: DataUploadPortalGroupType;
    };
    userGroups: Array<{
      index: number;
      name: string;
    }>;
  };
};
